import { Select, SelectProps, useTheme } from '@mui/material';

const DSSelect = (props: SelectProps) => {
  const { spacing, palette } = useTheme();

  return (
    <Select
      {...props}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: spacing(1, 2),
        borderRadius: '28px',
        background: 'rgba(255, 255, 255, 0.09)',
        color: palette.text.primary,
        '& .MuiOutlinedInput-notchedOutline': {
          border: 'none',
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
          border: 'none',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          border: 'none',
        },
        '& .MuiSelect-select': {
          fontSize: spacing(2),
          padding: spacing(1),
        },
        '& .MuiSelect-icon': {
          color: palette.text.primary,
        },
        ...props.sx,
      }}
      MenuProps={{
        PaperProps: {
          sx: {
            borderRadius: spacing(3.5),
            background: palette.paper.elevation8,
            boxShadow:
              '0px 3px 14px 2px rgba(0, 0, 0, 0.12), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 5px 5px -3px rgba(0, 0, 0, 0.20)',
            marginTop: spacing(1),
            '& .MuiMenuItem-root': {
              color: palette.text.primary,
              fontSize: spacing(2),
              padding: spacing(1, 2),
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              },
              '&.Mui-selected': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.15)',
                },
              },
            },
          },
        },
        ...props.MenuProps,
      }}
    />
  );
};

export default DSSelect;
